export const ADD_D2D_PILL = 'ADD_D2D_PILL';
export const ADD_D2D_PILL_DONE = 'ADD_D2D_PILL_DONE';
export const ADD_D2D_PILL_ERR = 'ADD_D2D_PILL_ERR';
export const EDIT_D2D_PILL = 'EDIT_D2D_PILL';
export const EDIT_D2D_PILL_DONE = 'EDIT_D2D_PILL_DONE';
export const EDIT_D2D_PILL_ERR = 'EDIT_D2D_PILL_ERR';
export const EDIT_D2D_PILL_SCHEDULE = 'EDIT_D2D_PILL_SCHEDULE';
export const REMOVE_D2D_PILL = 'REMOVE_D2D_PILL';
export const REMOVE_D2D_PILL_DONE = 'REMOVE_D2D_PILL_DONE';
export const REMOVE_D2D_PILL_ERR = 'REMOVE_D2D_PILL_ERR';
//# sourceMappingURL=actionTypes.js.map